import { render, staticRenderFns } from "./BasicsSupplier.vue?vue&type=template&id=72f87bff&scoped=true"
import script from "./BasicsSupplier.vue?vue&type=script&lang=js"
export * from "./BasicsSupplier.vue?vue&type=script&lang=js"
import style0 from "./BasicsSupplier.vue?vue&type=style&index=0&id=72f87bff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f87bff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f87bff')) {
      api.createRecord('72f87bff', component.options)
    } else {
      api.reload('72f87bff', component.options)
    }
    module.hot.accept("./BasicsSupplier.vue?vue&type=template&id=72f87bff&scoped=true", function () {
      api.rerender('72f87bff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsSupplier/BasicsSupplier.vue"
export default component.exports